"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _tabbable = require("./tabbable");

var TAB_KEY = 9;

var isTabKey = function isTabKey(event) {
  return event.keyCode === TAB_KEY;
}; // Traps focus in an element.


var focusTrap = function focusTrap(event, element) {
  var tabbable = (0, _tabbable.setTabbable)(element);
  if (!isTabKey(event)) return;

  if (event.shiftKey) {
    // If focus is on the first element, move focus to the last element
    if (event.target === tabbable.first) {
      event.preventDefault();
      tabbable.last.focus();
    }
  } else {
    // If focus is on the last element, move focus to the first element
    if (event.target === tabbable.last) {
      event.preventDefault();
      tabbable.first.focus();
    }
  }
};

var _default = focusTrap;
exports["default"] = _default;